import { render, staticRenderFns } from "./PayoutForm.vue?vue&type=template&id=2badf62b&"
import script from "./PayoutForm.vue?vue&type=script&lang=js&"
export * from "./PayoutForm.vue?vue&type=script&lang=js&"
import style0 from "./PayoutForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports